var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiv4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 120,
    viewBox: "0 0 109 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 120,
    rx: 20,
    fill: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.8 94.6C73.99 94.6 89.6 78.99 89.6 59.8C89.6 40.61 73.99 25 54.8 25C35.61 25 20 40.61 20 59.8C20 78.99 35.61 94.6 54.8 94.6ZM56.23 34.31C58.79 34.31 60.87 36.39 60.87 38.95C60.87 41.51 58.79 43.59 56.23 43.59C53.67 43.59 51.59 41.51 51.59 38.95C51.59 36.39 53.66 34.31 56.23 34.31ZM51.78 45.63H57.45C59.14 45.63 60.5 47 60.5 48.68V82.24C60.5 83.93 59.13 85.29 57.45 85.29C55.77 85.29 54.4 83.92 54.4 82.24V51.74H51.78C50.09 51.74 48.73 50.37 48.73 48.69C48.73 47.01 50.09 45.63 51.78 45.63Z",
    fill: "#00A90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv4);
export default __webpack_public_path__ + "static/media/div4.bb6e47cf5cc84df3e4960492db7e923f.svg";
export { ForwardRef as ReactComponent };